import { ActionIconWrapper } from '@components/Inbox/TitleBar/TitleBar.styled'
import ActionIcon from '@components/UI/ActionIcon'
import { ConnectedTrackedRoute } from '@components/UI/TrackedRoute'
import { useIntl } from '@context/Internationalization/useIntl'
import { EventTrackingNames } from '@enums'
import Theme from '@theme'

type Props = {
  campaignId: number
  redirectToPreview: VoidFunction
}

export const InboxTitleBarPreviewCampaignAction: React.FC<Props> = ({
  campaignId,
  redirectToPreview,
}) => {
  const { intl } = useIntl()

  return (
    <ConnectedTrackedRoute
      eventName={EventTrackingNames.ToolbarPreviewCampaign}
      campaignId={campaignId}
    >
      <ActionIconWrapper>
        <ActionIcon
          glyph="preview"
          highlighted={false}
          showNotification={false}
          color={Theme.grey900Color}
          tooltip={intl.formatMessage({ id: 'inbox.titlebar.action.preview' })}
          size={1.5}
          onClick={redirectToPreview}
          elementName="preview-campaign"
        />
      </ActionIconWrapper>
    </ConnectedTrackedRoute>
  )
}
